<template>
  <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="110">
      <FormItem label="运费（元）">
        <InputNumber v-model="form.postFee" :min="0" :precision="2" :active-change="false"></InputNumber>
      </FormItem>
      <FormItem label="保险费（元）" >
        <InputNumber v-model="form.insuranceFee" :min="0" :precision="2" :active-change="false"></InputNumber>
      </FormItem>
      <FormItem label="订单总额（元）" prop="totalAmount">
        <InputNumber v-model="form.totalAmount" :min="0" :precision="2" :active-change="false"></InputNumber>
      </FormItem>
      <FormItem label="业务员姓名">
        <Input v-model="form.salesmanName"></Input>
      </FormItem>
      <FormItem label="业务员手机号">
        <Input v-model="form.salesmanPhone"></Input>
      </FormItem>
      <FormItem>
        <Button @click="reset">重置</Button>
        <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
      </FormItem>
    </Form>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        totalAmount: [ { type:'number', required:true , message: '订单总额不能为空', trigger: 'blur,change' } ],
      },
      form: {
        id:null,
        postFee: null,
        insuranceFee:null,
        totalAmount:null,
        salesmanName:null,
        salesmanPhone:null
      },
      loading:false
    }
  },

  props:{
    data:{
      type:Object
    }
  },
  watch:{
    data(val){
      if(val){
        this.init()
      }
    }
  },


  methods: {
    init() {
      this.$utils.fill( this.form , this.data)
    },

    save() {
      let params = { ...this.form }

      this.loading = true
      console.log( params )
      this.$request.orderUpdate(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
        }
        this.loading = false
      })

    },
    reset(){
      this.$utils.fill(this.form , this.data)
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    }
  }
}
</script>
